module.exports = __webpack_public_path__ + "img/logo-light.3f843d70.svg";